import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { IMAGES } from "../data/content";

export const CTASection = () => {
  return (
    <section className="relative overflow-hidden bg-forest">
      <div className="absolute inset-0 opacity-20">
        <img src={IMAGES.facade2} alt="Modern architectural facade by Kotam Projects builders" className="h-full w-full object-cover" loading="lazy" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-forest via-forest/95 to-forest/70" />
      <div className="container-px relative py-24 lg:py-36">
        <div className="max-w-3xl">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="label text-gold"
          >
            Let's Build Together
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="mt-6 font-display font-light text-h2 text-white"
          >
            Ready to bring your vision to life?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-6 text-lg sm:text-xl text-white/70 leading-relaxed"
          >
            Whether it's a custom home or a renovation, our team is ready to
            deliver outstanding results — on time and within budget.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mt-10 flex flex-col sm:flex-row gap-4"
          >
            <Link
              to="/contact"
              data-testid="cta-request-quote"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-gold px-8 py-4 font-semibold text-forest-dark transition-transform hover:-translate-y-0.5"
            >
              Request a Quote
              <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
            <Link
              to="/services"
              data-testid="cta-explore-services"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 px-8 py-4 font-semibold text-white transition-colors hover:bg-white hover:text-forest"
            >
              Explore Services
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
